import React from 'react';
import { shape } from 'prop-types';
import { ThemeArticleOverview } from '../../../containers/ThemeArticleOverview';
import { ThemeMediaOverview } from '../../../containers/ThemeMediaOverview';
import { ThemeHeader } from '../../../components/headers/ThemeHeader';
import { NavbarFooterPageLayout } from '../../../layouts/NavbarAndFooterLayout';
import withApolloClient from '../../../hocs/withApolloClient';
import initApollo from '../../../api/initApollo';
import { FetchTheme } from '../../../api/queries/theme.gql';
import { FetchThemeAndArticles } from '../../../api/queries/themeAndArticles.gql';
import { FetchThemeAndMedia } from '../../../api/queries/themeAndMedia.gql';
import Section from '../../../layouts/styled';
import { PageMeta } from '../../../components/PageMeta';
import ThemeSubNavigation from '../../../containers/ThemeSubNavigation/ThemeSubNavigation';

const LIMIT = 24;

export async function getServerSideProps({ params }) {
  const client = initApollo();
  const { subThemeSlug } = params;

  const { data } = await client.query({
    query: FetchTheme,
    fetchPolicy: 'cache-first',
    variables: {
      themeSlug: subThemeSlug,
    },
  });

  if (!data?.theme) {
    return {
      notFound: true,
    };
  }

  // TODO: check where to return the status code
  return {
    props: {
      theme: data?.theme,
    },
  };
}

function ThemeOverview({ theme }) {
  return (
    <Section>
      <PageMeta
        title={`${theme?.name} thema pagina - BNNVARA`}
        description={theme?.description}
        type="static page"
        image={theme?.backgroundImageUrl}
      />
      <NavbarFooterPageLayout>
        <ThemeHeader theme={theme} />
        <ThemeSubNavigation />
        <ThemeArticleOverview
          theme={theme}
          loadMoreQuery={FetchThemeAndArticles}
          limit={LIMIT}
        />
        <ThemeMediaOverview
          theme={theme}
          loadMoreQuery={FetchThemeAndMedia}
          limit={LIMIT}
        />
      </NavbarFooterPageLayout>
    </Section>
  );
}

ThemeOverview.propTypes = {
  theme: shape(),
};

export default withApolloClient(ThemeOverview, { ssr: false });
